 
import { cartItemsFetch } from 'reduxModules/cart'
import _ from 'lodash'
import { navigate } from '../../../utils/navigation'

import { hijackFetch, releaseHijackedUser } from './'
import { subscriptionSummaryFetch } from '../subscriptions'
import notifications, { toastSuccess } from '../../../global/notifications'

export const dispatchHijack = (dispatch, userId) =>
  dispatch(hijackFetch(userId)()).then(() => {
    dispatch(cartItemsFetch())
    navigate('/account')
    toastSuccess(notifications.userImpersonated)
  })

export const dispatchSubscriptionFetch = (dispatch, subscriptionId) => {
  dispatch(subscriptionSummaryFetch(subscriptionId)())
}

export default (dispatch) => ({
  hijack: (userId) => dispatchHijack(dispatch, userId),
  releaseHijacked: () => dispatch(releaseHijackedUser()),
  loadSubscription: (subscriptionId) =>
    dispatchSubscriptionFetch(dispatch, subscriptionId)
})
